import withRouter from "hoc/withRouter";
import {
  Button,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import branchesService from "services/admin/branchesService";
import { useGetBranches } from "hooks/useGetBranches";
import { Link } from "react-router-dom";
import { FaTrash, FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";

const BranchList = () => {
  const {
    data: branchesResponse,
    isLoading,
    refetch,
  } = useGetBranches({
    type: "TICKET",
    orgID: localStorage.getItem("orgID") || "",
  });

  console.log("Branches: ", branchesResponse);

  const handleDelete = async (id: string) => {
    await branchesService.delete(id);
    refetch();
  };

  function buildContent() {
    if (isLoading) {
      return (
        <div className="text-center">
          <CircularProgress></CircularProgress>
        </div>
      );
    }
    if ((branchesResponse?.data as any)?.length === 0) {
      return (
        <div>
          Филиалы отсутсвуют. Чтобы добавить филиал пожалуйста, нажмите на кнопку "Добавить" сверху
        </div>
      );
    }
    if ((branchesResponse?.data as any)?.length > 0) {
      return (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Код</TableCell>
              <TableCell>Название</TableCell>
              <TableCell>Действия</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(branchesResponse?.data as any)?.map((c: any, index: number) => (
              <TableRow key={c.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{c.code}</TableCell>
                <TableCell>{c.name}</TableCell>
                <TableCell>
                  <div className="flex gap-2 items-center">
                    <Link to={`/admin/branches/edit/${c.id}`}>
                      <FaPencil />
                    </Link>
                    <IconButton color="error" onClick={() => handleDelete(c.id)}>
                      <FaTrashAlt />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      );
    }
  }
  return (
    <ListPage pageTitle="Список филиалов" pathToAdd={`/admin/branches/add`}>
      <div className="m-t-32">{buildContent()}</div>
    </ListPage>
  );
};

export default withRouter(BranchList);
